import { Retailer } from '@/core/entity';
import { IFileGateway, IRetailerGateway, UpdaterFunc, PresenterFunc } from '@/core/interface';

export class UpdateRetailer {
  constructor(
    private readonly fileGateway: IFileGateway,
    private readonly retailerGateway: IRetailerGateway,
  ) { }

  public async execute(
    id: string,
    name: string,
    country: string,
    desId: string,
    file: File | string,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      let uploadItem = null;
      if (file instanceof File) {
        uploadItem = await this.retailerGateway.getRetailerLogoUploadUrl(file.type);

        await this.fileGateway.upload(file, uploadItem.uploadUrl);
      }

      const result = await this.retailerGateway.updateRetailer({
        id,
        name,
        logo: uploadItem ? uploadItem.fileUri : file as string,
        country,
        desId,
      }, undefined, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
